import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { MEDIA_URL } from '../../config/constants';

const AboutHero = () => {
  const { t } = useTranslation('about');

  return (
    <section className="about-hero">
      <div className="about-hero-content">
        <div className="about-hero-text">
          <h1 className="about-hero-title">{t('hero.title')}</h1>
          <p className="about-hero-description">
            {t('hero.description')}
          </p>
        </div>
        <img
          src={`${MEDIA_URL}/images/about/GET IN TOUCH/sun-catchers-about-us.webp`}
          alt="Sun Catchers campervans"
          className="about-hero-image"
        />
      </div>
    </section>
  );
};

export default AboutHero;
